<template>
  <div>
  <h4>Inventar</h4>
    <div class="card p-3">
      <variant-inventory-item
          class="inventory-list"
          v-for="(variant, variantIndex) in variants"
          :key="variant.id"
          :variant="variant"
          :variant-index="variantIndex"
      ></variant-inventory-item>
      <label v-if="total > 0">Gesamt: {{total}} Einheiten <template v-if="showWeight"> ( {{totalWeight}} )</template></label>
    </div>
  </div>
</template>
<script>
import VariantInventoryItem from "@/pages/EditProductPage/Variants/VariantInventoryItem";
import platformSettings from '~config/settings'
export default {
  props: ['variants'],
  components: {VariantInventoryItem},
  computed: {
      total: function () {
          let sum = 0;
          this.variants.forEach(function (item) {
              sum += parseInt(item.inventoryQuantity) || 0;
          });
          return sum;
      },
      totalWeight: function () {
          let sum = 0;
          this.variants.forEach(function (item) {
              let w = parseFloat(item.weight)
              if (item.weightUnit === 'GRAMS') {
                  w = w / 1000
              }
              w = w * item.inventoryQuantity
              sum += w
          });
          return sum + ' kg';
      }
  },
  data() {
      return {
          showWeight: platformSettings.productShowTotalWeight
      }
  }
}
</script>
